// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2513x","list":"PatternAutocomplete_list__1wN2T"};